<template>
    <div class="container-scroller">
      <div class="container-fluid page-body-wrapper full-page-wrapper">
        <div class="content-wrapper d-flex align-items-center auth">
          <div class="row flex-grow">
            <div class="col-lg-4 mx-auto">
              <div class="auth-form-light text-center p-5">
                <div class="brand-logo justify-content-center">
                  <img :src="pic" alt="Profile Picture" class="profile-pic">
                </div>
                <h4>Set Password</h4>
                <p>Hello <strong>{{ name }}</strong>. A verification code was sent to your phone. Please enter the code below.</p>

                <form @submit.prevent="login">
                  <div class="form-group">
                    <input type="text" v-model="message.code" class="form-control" placeholder="OTP Code" required>
                  </div>

                  <button type="submit" class="btn btn-block btn-success btn-lg font-weight-medium auth-form-btn">
                    Submit
                  </button>
                </form>

                <div class="my-2 d-flex justify-content-between align-items-center">
                  <div class="form-check">
                    <input type="checkbox" id="keepSignedIn" class="form-check-input">
                    <label for="keepSignedIn" class="form-check-label text-muted">Keep me signed in</label>
                  </div>
                  <router-link to="/" class="auth-link text-black">Login?</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: 'OtpVerification',
    data() {
      return {
        message: { code: '', ip_address: '', date_time: '',info:'' },
        name: '',
        pic: '',
        user: JSON.parse(localStorage.getItem("user")) || {},
      };
    },
    computed: {
    userEmail() {
      return this.user?.email || "";
    },
  },
    created() {
      console.log("OTP Verification Component Initialized...");

      const token = localStorage.getItem("token");
      this.pic = localStorage.getItem("pic") || "";
      this.name = localStorage.getItem("name") || "";
      this.message.info = localStorage.getItem("info") || ""; // Ensure info is set
      this.message.email = JSON.parse(localStorage.getItem("user"))?.email || "";

      console.log("Token:", token);
    console.log("Pic:", this.pic);
    console.log("Name:", this.name);
    console.log("Info:", this.message.info);

      if (!token) {
        localStorage.clear();
        this.$router.push({ name: "index" });
      }

      this.getIp();
      this.getTime();
    },
    methods: {
        login() {
    this.$loading(true);

    // Retrieve token from local storage
    const token = localStorage.getItem("token");

    // Debugging: Check if token exists
    console.log("Google Token:", token);

    if (!token) {
        this.$swal({ title: "Error", text: "Google token is missing!", icon: "error" });
        this.$loading(false);
        return;
    }

    // Ensure `info` contains the Google token
    this.message = this.message || {}; // Ensure message is not undefined
    this.message.info = token;

     // Debugging: Log request payload before sending
     console.log("Payload sent to backend:", JSON.stringify(this.message, null, 2));


    let uri = `/api/auth/attemptCredentials`;
    this.axios.post(uri, this.message)
        .then((response) => {
            this.$loading(false);
            if (response.data.status) {
                if (response.data.user.status === 'ACTIVE') {
                    if (response.data.user.user_type === 'ADMIN') {
                        localStorage.setItem('token', response.data.access_token);
                        // localStorage.setItem('fname', response.data.user.fname);
                        // localStorage.setItem('lname', response.data.user.lname);
                        localStorage.setItem('auth', 'yes');
                        localStorage.removeItem('info');
                        this.$toast.open({ message: 'You have successfully signed in.', type: 'success', position: 'top' });
                        this.$router.push({ name: 'home' });
                    } else {
                        this.$swal({ title: "Access Denied!", text: 'Unauthorized access', icon: "warning" });
                    }
                } else {
                    this.$swal({ title: "Access Denied!", text: 'Inactive account, contact support', icon: "warning" });
                }
            } else {
                this.$swal({ title: "Password", text: response.data.message, icon: "warning" });
            }
        })
        .catch(error => {
            this.$loading(false);
            localStorage.removeItem('token');
            console.error("Login Error:", error.response);

            if (error.response && error.response.data.errors) {
                this.$swal({ title: "Error", text: error.response.data.errors.info[0], icon: "error" });
            } else {
                this.$toast.open({ message: 'Something went wrong!', type: 'error', position: 'top' });
            }
        });
}

,
      async getIp() {
        try {
          let response = await this.axios.get('https://api.ipify.org/?format=json');
          this.message.ip_address = response.data.ip;
        } catch (error) {
          console.error("Failed to fetch IP address.");
        }
      },
      getTime() {
        const today = new Date();
        this.message.date_time = today.toISOString().slice(0, 16).replace('T', ' ');
      }
    }
  };
  </script>

  <style scoped>
  .profile-pic {
    width: 150px;
    border-radius: 50%;
  }
  </style>
